export default __webpack_public_path__ + "static/media/bg_mixed.52adf085.png";